/* eslint-disable react/jsx-key */
import { useGetDepartmentByOrganization } from 'features/services/api';
import { DepartmentInfoDto } from 'features/services/apiGenerated';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Column } from 'react-table';
import { stringDateToLocaleString } from 'utils/dateUtils';

import { Table, TableCellChevronRight } from '../generic/Table';

export const OrganizationDepartmentsTable: React.FC<{ orgId: number }> = ({ orgId }: { orgId: number }) => {
  const { t } = useTranslation();

  const { data, error, isLoading } = useGetDepartmentByOrganization({ organizationId: orgId });

  const onRowClick = (row: DepartmentInfoDto) => {
    navigate(`/management/departments/${row.id}`);
  };

  const navigate = useNavigate();
  // eslint-disable-next-line @typescript-eslint/ban-types
  const columns: Column<DepartmentInfoDto>[] = [
    {
      Header: t('Afdeling').toString(),
      accessor: 'name',
    },
    {
      Header: t('Medewerkers').toString(),
      accessor: 'employeeCount',
    },
    {
      Header: t('Aantal Rapportages').toString(),
      accessor: 'reportCount',
    },
    {
      Header: t('Laatste wijziging').toString(),
      accessor: (row) => {
        if (!row.lastModifiedDate) {
          return '';
        }
        return stringDateToLocaleString(row.lastModifiedDate);
      },
      sortType: (rowA, rowB) => {
        if (rowA.original.lastModifiedDate === undefined || rowA.original.lastModifiedDate === null) return 0;
        if (rowB.original.lastModifiedDate === undefined || rowB.original.lastModifiedDate === null) return 0;
        if (new Date(rowA.original.lastModifiedDate) > new Date(rowB.original.lastModifiedDate)) return 1;
        if (new Date(rowB.original.lastModifiedDate) > new Date(rowA.original.lastModifiedDate)) return -1;
        return 0;
      },
    },
    // {
    //   Header: t('Actief').toString(),
    //   accessor: (row) => (row.isActive ? TableCellActiveIcon : TableCellInactiveIcon),
    // },
    {
      Header: ' ',
      accessor: () => TableCellChevronRight,
    },
  ];

  return <Table columns={columns} data={data ?? []} onRowClick={onRowClick} isLoading={isLoading} error={error} />;
};
